/**
 * An item's title, as a link when it has somewhere to go and as plain text when it does not.
 *
 * One component in front of the four places that render a publication link — the Log's Title
 * cell, the Log's URL cell, the Review queue and the Actions screen. The first three each
 * wrote their own falsy check and the fourth did not, which is the bug this closes; the rule
 * itself lives in `links.ts` so `make web-check` can reach it. See that file for the story.
 */

import type { ReactNode } from "react";

import { followable } from "../links";

export function ItemLink({
  url,
  children,
  title,
}: {
  url?: string | null;
  children: ReactNode;
  title?: string;
}) {
  if (!followable(url)) {
    // Plain text, not a disabled-looking link: there is nothing to go to, and a link that
    // does nothing is worse than no link because it invites the click.
    return <span title={title}>{children}</span>;
  }
  return (
    <a href={(url ?? "").trim()} target="_blank" rel="noreferrer noopener" title={title}>
      {children}
    </a>
  );
}
